// firebase.js (modular SDK)
import { initializeApp } from "firebase/app";
import { getAuth, browserSessionPersistence } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Configurazione del progetto
const firebaseConfig = {
  apiKey: "AIzaSyDcaOoEhIVyYuzQpmvOra7iZbbC_rXQi-A",
  authDomain: "totalserviceweb.firebaseapp.com",
  projectId: "totalserviceweb",
  storageBucket: "totalserviceweb.firebasestorage.app",
  messagingSenderId: "120831324407",
  appId: "1:120831324407:web:bda21fa387a1c378c423f2",
  measurementId: "G-18P4K9Q1XF"
};


const app = initializeApp(firebaseConfig);

const auth = getAuth(app);
const db = getFirestore(app);
const firestore = getFirestore(app);

export { auth, db, firestore, browserSessionPersistence };
